/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_HiitInputs */

const en_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIIT`)
};

const es_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIIT`)
};

const fr_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIIT`)
};

const de_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIIT`)
};

const ja_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIIT`)
};

const zh_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高强度间歇训练 (HIIT)`)
};

const ar_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدريب متواتر عالي الكثافة (HIIT)`)
};

const id_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIIT`)
};

const it_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIIT`)
};

const ru_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ВИИТ`)
};

const pt_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIIT`)
};

const ko_val_hiit = /** @type {(inputs: Val_HiitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIIT (고강도 인터벌 트레이닝)`)
};

/**
* | output |
* | --- |
* | "HIIT" |
*
* @param {Val_HiitInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_hiit = /** @type {((inputs?: Val_HiitInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_HiitInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_hiit(inputs)
	if (locale === "es") return es_val_hiit(inputs)
	if (locale === "fr") return fr_val_hiit(inputs)
	if (locale === "de") return de_val_hiit(inputs)
	if (locale === "ja") return ja_val_hiit(inputs)
	if (locale === "zh") return zh_val_hiit(inputs)
	if (locale === "ar") return ar_val_hiit(inputs)
	if (locale === "id") return id_val_hiit(inputs)
	if (locale === "it") return it_val_hiit(inputs)
	if (locale === "ru") return ru_val_hiit(inputs)
	if (locale === "pt") return pt_val_hiit(inputs)
	return ko_val_hiit(inputs)
});